import React from 'react'
import { RootState, useAppDispatch, useAppSelector } from '../../State/Store';
import Lottie from "lottie-react";
import error from "../../assets/Under Maintenance.json"
import { useNavigate } from 'react-router-dom';
import { clearGlobalError } from '../../State/UiSlice';
export const GlobalError = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const lastError = useAppSelector((s: RootState) => s.ui.lastError);
     const detail =
    typeof lastError?.data === "string"
      ? lastError.data
      : lastError?.data
      ? JSON.stringify(lastError.data)
      : null;
 const handleDismiss =async (path?:string) => { 
    
   await dispatch(clearGlobalError())
  
   }    
  return (
    <div className='WidthFull h-screen flex flex-col items-center '>
     <div className='text-center space-y-3'>
           <h1 className="text-7xl font-bold text-red-600">Error Found</h1> 
           <p className="text-3xl font-bold text-gray-600">We’re having trouble right now. ⛔️⛔️⛔️</p>
        <p className="text-2xl font-bold text-gray-600">{lastError?.message ?? "Something went wrong"}</p>
     </div>
      
        <Lottie
            animationData={error}
            loop
            autoplay
            style={{ width: 700, height: 700 }}
          />
         <div className='flex w-full justify-evenly items-center'>
            <button    className="px-16 py-5 rounded-2xl border-none  btn-shine text-white" style={{backgroundImage: "linear-gradient(to right,#2ab2ff , #d815f8)",}} onClick={() => { handleDismiss() }}>Dismiss</button>
            <button    className="px-16 py-5 rounded-2xl border-none  btn-shine text-white" style={{backgroundImage: "linear-gradient(to right,#2ab2ff , #d815f8)",}} onClick={() => { handleDismiss("/") }}>Go To HomePage</button>
         </div>
    </div>
  )
}
